<template>
  <nav class="navigation">
    <div class="container">
      <NavigationComponent v-bind="{ ...$attrs, logo, icons, padding: '20px 0' }">
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
          ><slot :name="slot" v-bind="scope"
        /></template>
      </NavigationComponent>
    </div>
  </nav>
</template>

<script>
import { NavigationComponent } from 'vue-elder-navigation'
export default {
  data() {
    return {
      logo: {
        src: '/api/client/logo',
        height: 30,
        alt: 'Kvass',
      },
      icons: {
        menu: { icon: ['fal', 'bars'], size: 'lg' },
        menuClose: { icon: ['fal', 'times'], size: 'lg' },
        expand: { icon: ['fal', 'angle-down'] },
        collapse: { icon: ['fal', 'angle-up'] },
      },
    }
  },
  components: {
    NavigationComponent,
  },
}
</script>

<style lang="scss">
.navigation {
  background-color: white;

  .elder__navigation-component {
    padding: 0.5rem 1rem;

    @for $i from 1 through 10 {
      &.indent--#{$i} {
        margin-left: 1rem * $i;
      }
    }
  }
}
</style>
